document.addEventListener('click', function (e) {
  const swatch = e.target.closest('[card-data-swatch]');
  if (!swatch) return;

  const cardId = swatch.dataset.cardId;
  const imageUrl = swatch.dataset.variantImage;
  const sectionId = swatch.dataset.sectionId;
  const variantUrl = swatch.dataset.variantUrl
  const img = document.getElementById(`ProductCardImage-${cardId}-${sectionId}`);

  if (img && imageUrl) {
    img.removeAttribute('srcset');
    img.src = imageUrl;
  }

  const group = swatch.closest('[data-swatch-group]');
  group.querySelectorAll('[card-data-swatch]').forEach(s => s.classList.remove('is-selected'));
  swatch.classList.add('is-selected');

  const productCardWrap = swatch.closest('.product-card-wrapper');
  productCardWrap.querySelectorAll('[data-card-product-link]').forEach(link => link.href = variantUrl);
});

document.addEventListener('keydown', function (e) {
  if ((e.key === 'Enter' || e.key === ' ') && e.target.matches('[card-data-swatch]')) {
    e.preventDefault();
    e.target.click();
  }
});